import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="Risultati reali" className="border-y border-grape/10 bg-white/70" data-id="element-176" data-mp="2wxqc25ic86f9">
      <div className="mx-auto max-w-5xl px-5 py-8" data-id="element-177" data-mp="2wvdv9vobg23s">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-178" data-mp="2iww41nz7c7h4">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-179" data-mp="2nwin4e1pohxu">
              <dt className="font-display text-4xl font-black text-plum sm:text-5xl" data-id="element-180" data-mp="2nz4w8i4935i6">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-plum/60" data-id="element-181" data-mp="2961f2bukmtrz">{s.label}</dd>
            </div>)}
        </dl>
        
      </div>
    </section>;
}